console.log('show')

import store from './store'
import Summary from './components/summary'
import Steps from './components/steps'
import Products from './components/products'
import Form from './components/form'
import Confirmation from './components/confirmation'
import ProductSummary from './components/productSummary'
import FormSummary from './components/formSummary'
import ProductNetConfig from './components/productNetConfig'
import ProductEnergyConfig from './components/productEnergyConfig'
import ProductFixConfig from './components/productFixConfig'
import ProductCellConfig from './components/productCellConfig'
// import ProductTvConfig from './components/productTvConfig'
import ProductPerseoConfig from './components/productPerseoConfig'
import { mapMutations, mapState } from 'vuex'

Vue.component('configurator-summary', Summary)
Vue.component('configurator-steps', Steps)
Vue.component('configurator-products', Products)
Vue.component('configurator-form', Form)
Vue.component('configurator-confirmation', Confirmation)
Vue.component('product-summary', ProductSummary)
Vue.component('form-summary', FormSummary)
Vue.component('product-net-config', ProductNetConfig)
Vue.component('product-energy-config', ProductEnergyConfig)
Vue.component('product-fix-config', ProductFixConfig)
Vue.component('product-cell-config', ProductCellConfig)
// Vue.component('product-tv-config', ProductTvConfig)
Vue.component('product-perseo-config', ProductPerseoConfig)


const configurator = new Vue({
    el: '#configurator',

    store,

    created() {
        this.setProducts(products ?? [])
        this.setConfigurations(configurations ?? [])
        this.setInitialSelection(selection ?? null)
    },

    mounted() {
        document.getElementById('page-loader').classList.add('mounted')
    },

    methods: {

        ...mapMutations('products', [
            'setProducts',
            'setConfigurations',
            'setInitialSelection',
        ])

    },

})
